module.exports = __webpack_public_path__ + "static/media/search.457a8245.svg";